// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locations-table thead th:last-child,
.locations-table tbody td:last-child {
  min-width: 5.5rem;
  width: 5.5rem;
  text-align: center;
}

.locations-table tbody td:last-child {
  white-space: nowrap;
}

.locations-table thead th:nth-child(5),
.locations-table tbody td:nth-child(5) {
  min-width: 11rem;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Locations/Locations.css"],"names":[],"mappings":"AAAA;;EAEE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".locations-table thead th:last-child,\n.locations-table tbody td:last-child {\n  min-width: 5.5rem;\n  width: 5.5rem;\n  text-align: center;\n}\n\n.locations-table tbody td:last-child {\n  white-space: nowrap;\n}\n\n.locations-table thead th:nth-child(5),\n.locations-table tbody td:nth-child(5) {\n  min-width: 11rem;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
